export default "__VITE_ASSET__CvWpJZuo__"